export default __webpack_public_path__ + "static/media/chat-contact.0957ff43.png";